/**
 * Status Constants
 * Centralized status values used throughout the application
 */
// User Status
export const USER_STATUS = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    SUSPENDED: 'SUSPENDED',
    PENDING_VERIFICATION: 'PENDING_VERIFICATION',
};
// User Status (lowercase variants for frontend)
export const USER_STATUS_LOWERCASE = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    SUSPENDED: 'suspended',
    PENDING: 'pending',
};
// Project Status
export const PROJECT_STATUS = {
    DRAFT: 'DRAFT',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    ARCHIVED: 'ARCHIVED',
};
// Case Status
export const CASE_STATUS = {
    DRAFT: 'DRAFT',
    PUBLISHED: 'PUBLISHED',
    ARCHIVED: 'ARCHIVED',
};
// Team Member Status
export const TEAM_MEMBER_STATUS = {
    ACTIVE: 'ACTIVE',
    ON_LEAVE: 'ON_LEAVE',
    INACTIVE: 'INACTIVE',
};
// Generic Status
export const GENERIC_STATUS = {
    OK: 'ok',
    ERROR: 'error',
    SUCCESS: 'success',
    FAILED: 'failed',
    PENDING: 'pending',
    LOADING: 'loading',
};
// Health Check Status
export const HEALTH_STATUS = {
    OK: 'ok',
    DEGRADED: 'degraded',
    UNHEALTHY: 'unhealthy',
    CHECKING: 'checking',
    HEALTHY: 'healthy',
    WARNING: 'warning',
    CRITICAL: 'critical',
    READY: 'ready',
    NOT_READY: 'not ready',
    ALIVE: 'alive',
};
